import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      nav("/comparateur");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/40 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md rounded-2xl border border-border bg-card p-8 shadow-sm"
      >
        <Link to="/" className="mb-6 flex items-center gap-2">
          <img src="/logo192.png" alt="PanierMoinsCher" className="h-9 w-9 rounded-xl shadow-sm" />
          <span className="font-display text-lg font-800 text-secondary">PanierMoinsCher</span>
        </Link>
        <h1 className="font-display text-2xl font-800 text-secondary">Connexion</h1>
        <p className="mt-1 text-sm text-muted-foreground">Accédez à vos paniers et alertes.</p>

        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} required onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="password">Mot de passe</Label>
            <Input id="password" type="password" value={password} required onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="mt-1.5" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
          <Button type="submit" className="w-full rounded-full" disabled={loading} data-testid="login-submit">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Se connecter
          </Button>
        </form>
        <p className="mt-5 text-center text-sm text-muted-foreground">
          Pas encore de compte ?{" "}
          <Link to="/inscription" className="font-semibold text-primary hover:underline" data-testid="link-register">
            Créer un compte
          </Link>
        </p>
      </motion.div>
    </div>
  );
}
